import { Contracts } from '../types';

const contracts: Contracts = {
  merkleRedeem: '',
  merkleOrchard: '',
  multicall: '0xca11bde05977b3631167028862be2a173976ca11',
  authorizer: '0x58c4281C3E42Bc33d77adeD5aD6aed57cD8c793a',
  vault: '0xD25E02047E76b688445ab154785F2642c6fe3f73',
  weightedPoolFactory: '0x47B7bdA16AB8B617E976c83A2c3c8664944d8Ed2',
  stablePoolFactory: '0x7dF194500b8b8dcFe6A0b8E412f8a166c89Bf255',
  lidoRelayer: '',
  balancerHelpers: '0xDCE2ea355530c098f5B9410b6B2663E0FFf246Bf',
  batchRelayer: '0x6Fa242ca188A128e7533c60373E2245eC22f65D9',
  gaugeFactory: '',
  balancerMinter: '',
  gaugeController: '',
  tokenAdmin: '',
  veBAL: '',
  veDelegationProxy: '',
  veBALHelpers: '',
  feeDistributor: '',
  feeDistributorDeprecated: '',
  faucet: '',
  gaugeRewardsHelper: '',
};

export default contracts;
